"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionGroupV3_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PermissionGroupDefaults_1 = require("./PermissionGroupDefaults");
var UserPermissionGroupMembership_1 = require("./UserPermissionGroupMembership");
var User_1 = require("./User");
var PermissionGroupV3_Factory = /** @class */ (function () {
    function PermissionGroupV3_Factory() {
    }
    PermissionGroupV3_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Name: model.Name,
            PermissionGroupDefaults: model.PermissionGroupDefaults && model.PermissionGroupDefaults.map(function (i) { return PermissionGroupDefaults_1.PermissionGroupDefaults_Factory.CreateIncoming(i); }),
            PermissionGroupID: model.PermissionGroupID,
            RestrictedToFeature: model.RestrictedToFeature,
            RoleTypeId: model.RoleTypeId,
            UserPermissionGroupMemberships: model.UserPermissionGroupMemberships && model.UserPermissionGroupMemberships.map(function (i) { return UserPermissionGroupMembership_1.UserPermissionGroupMembership_Factory.CreateIncoming(i); }),
            Users: model.Users && model.Users.map(function (i) { return User_1.User_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    PermissionGroupV3_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            Name: model.Name,
            PermissionGroupDefaults: model.PermissionGroupDefaults && model.PermissionGroupDefaults.map(function (i) { return PermissionGroupDefaults_1.PermissionGroupDefaults_Factory.CreateOutgoing(i); }),
            PermissionGroupID: model.PermissionGroupID,
            RestrictedToFeature: model.RestrictedToFeature,
            RoleTypeId: model.RoleTypeId,
            UserPermissionGroupMemberships: model.UserPermissionGroupMemberships && model.UserPermissionGroupMemberships.map(function (i) { return UserPermissionGroupMembership_1.UserPermissionGroupMembership_Factory.CreateOutgoing(i); }),
            Users: model.Users && model.Users.map(function (i) { return User_1.User_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return PermissionGroupV3_Factory;
}());
exports.PermissionGroupV3_Factory = PermissionGroupV3_Factory;
